<script>
    export let cl
    export let price = 0
    export let originalPrice = 0

    function formatted(p) {
        return (p ? p / 100 : 0).toFixed(2)
    }
</script>
<style>
    h3 {
        display: inline-block;
    }

    .strikethrough {
        text-decoration: line-through;
    }
</style>
<div class="{cl}">
    {#if price === originalPrice}
        <h3 class='self-end bold'>${formatted(price)} USD</h3>
    {:else}
        <h3 class='self-end strikethrough mr1 grayText'>${formatted(originalPrice)}</h3>
        <h3 class='self-end bold'>${formatted(price)} USD</h3>
    {/if}

</div>